import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface DataSourceRenameDialogProps {
    isOpen: boolean;
    initialName: string;
    onClose: () => void;
    onRename: (newName: string) => Promise<void>;
}

const DataSourceRenameDialog: React.FC<DataSourceRenameDialogProps> = ({
                                                                           isOpen,
                                                                           initialName,
                                                                           onClose,
                                                                           onRename
                                                                       }) => {
    const [name, setName] = useState(initialName);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!name.trim()) {
            setError('Name cannot be empty');
            return;
        }

        setIsSubmitting(true);
        setError(null);

        try {
            await onRename(name.trim());
            onClose();
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to rename data source');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal show={isOpen} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Rename Data Source</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>New Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter new name"
                            autoFocus
                        />
                    </Form.Group>
                    {error && (
                        <div className="text-danger mt-2">{error}</div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="primary" disabled={isSubmitting}>
                        {isSubmitting ? 'Renaming...' : 'Rename'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default DataSourceRenameDialog;